import NomenclaturesController from './nomenclatures.controller';

export default {
	template: require('./nomenclatures.html'),
	controller: NomenclaturesController
};
